/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var onlyUnique = function (value, index, self) {
    return self.indexOf(value) === index;
};
exports.uniqueArray = function (array) { return array.filter(onlyUnique); };